import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Radio, RadioField, RadioGroup } from '@/common/components/radio';
import { Text } from '@/common/components/text';

export const Route = createFileRoute(
  '/applications/$application-id/identity-check/security-questions'
)({
  component: SecurityQuestionsComponent
});

function SecurityQuestionsComponent() {
  return (
    <div className="p-8">
      <Heading>Authentication Questions</Heading>

      <Text>Please answer the following questions to verify identity.</Text>

      <Fieldset>
        <Legend>1. Question goes here</Legend>
        <RadioGroup name="q1">
          <RadioField>
            <Radio value="q1a1" />
            <Label>Answer 1</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a2" />
            <Label>Answer 2</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a3" />
            <Label>Answer 3</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a4" />
            <Label>Answer 4</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <Fieldset>
        <Legend>2. Question goes here</Legend>
        <RadioGroup name="q1">
          <RadioField>
            <Radio value="q1a1" />
            <Label>Answer 1</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a2" />
            <Label>Answer 2</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a3" />
            <Label>Answer 3</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a4" />
            <Label>Answer 4</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <Fieldset>
        <Legend>3. Question goes here</Legend>
        <RadioGroup name="q1">
          <RadioField>
            <Radio value="q1a1" />
            <Label>Answer 1</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a2" />
            <Label>Answer 2</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a3" />
            <Label>Answer 3</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a4" />
            <Label>Answer 4</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <Fieldset>
        <Legend>4. Question goes here</Legend>
        <RadioGroup name="q1">
          <RadioField>
            <Radio value="q1a1" />
            <Label>Answer 1</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a2" />
            <Label>Answer 2</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a3" />
            <Label>Answer 3</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a4" />
            <Label>Answer 4</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <Fieldset>
        <Legend>5. Question goes here</Legend>
        <RadioGroup name="q1">
          <RadioField>
            <Radio value="q1a1" />
            <Label>Answer 1</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a2" />
            <Label>Answer 2</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a3" />
            <Label>Answer 3</Label>
          </RadioField>
          <RadioField>
            <Radio value="q1a4" />
            <Label>Answer 4</Label>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/billing-preferences" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
